// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"353":"c984273b","774":"50eaf170","787":"3816698d","964":"e581ab1f"}[chunkId] + ".chunk.js";
};